import React, { useEffect, useState } from "react";
import "./App.css";
import Header from "./component/header/Header";
import Footer from "./component/footer/Footer";
import {
  Grid,
  Stack,
  useMediaQuery,
  useTheme /*, Typography */,
} from "@mui/material";
import CustomScroll from "./component/common/CustomScrollButton/CustomScroll";
import HomePage from "./component/home/HomePage";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import EmbeddedHTMLContent from "./component/EmbeddedHTML/EmbeddedHTMLContent";
//import Beta from "./component/common/Beta/Beta";
import PageNotFound from "./component/PageNotFound/PageNotFound";
import AddAffiliateForm from "./component/AddAffilateForm/AddAffiliateForm";
import ProductListing from "./component/common/ProductListing/ProductListing";
import HasAccess from "./component/common/HasAccess/HasAccess";
//import { serviceGETCountryCode } from "./api/service/services";
import ProductDetails from "./component/ProductDetails/ProductDetails";
import Analytics from "./component/Analytics";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showWarning, setShowWarning] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // Check for small screens

  const showAnalytics = process.env.REACT_APP_SHOW_ANALYTICS === "true";

  const termsAndConditionsString = localStorage.getItem("termsAndConditions");
  let title = "";
  let content = "";
  if (termsAndConditionsString) {
    const { title: storedTitle, content: storedContent } = JSON.parse(
      termsAndConditionsString
    );
    title = storedTitle;
    content = storedContent;
  }
  /* 
  useEffect(() => {
    const checkUserLocation = async () => {
      try {
        // Use a geolocation API
        const country_code = await serviceGETCountryCode();

        if (country_code === "IN") {
          setHasAccess(true); // Grant access if user is from India
        } else {
          setHasAccess(false); // Deny access otherwise
        }
      } catch (error) {
        console.error("Error fetching location:", error);
        setHasAccess(false); // Deny access in case of an error
      }
    };

    checkUserLocation();
  }, []); */

  // const { title, content } = location.state || {};
  useEffect(() => {
    if (location.pathname === "/") {
      const searchParams = location.search;
      navigate(`/home${searchParams}`);
    }
  }, [navigate, location]);

  useEffect(() => {}, [title, content, location]);

  useEffect(() => {
    if (location.hash) {
      try {
        const decodedHash = decodeURIComponent(location.hash);
        const safeSelector = CSS.escape(decodedHash);
        const element = document.querySelector(safeSelector);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } catch (error) {
        console.error("Invalid hash selector", error);
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.hash]);

  const handleCountryChange = (
    country: { label: string; value: string } | null
  ) => {
    /*     if (country && country.value !== "IN") { */
    if (country && country.label !== "India") {
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
  };

  return (
    <div className="App">
      <Stack
        className="stack"
        px={2}
        bgcolor="common.white"
        height={window.innerHeight}
        borderRadius={"9px"}
      >
        {" "}
        <CustomScroll>
          <Grid
            container
            gap={1}
            flexDirection="column"
            display={"flex"}
            justifyContent={"center"}
            alignContent={"center"}
          >
            {/*   <Grid item xs={12} md={12} lg={12} className="beta">
              <Beta />
            </Grid> */}
            {showWarning && (
              <Grid item xs={12} md={12} lg={12} className="hasAccess">
                <HasAccess />
              </Grid>
            )}
          {/*   <Grid
              item
              bgcolor="#FCFCFC"
              borderRadius={"14px"}
              spacing={2}
              boxShadow={` 0px 1px 4px 0px #00000040, 0px 0px 4px 0px #0000001A inset`}
              xs={12}
              md={12}
              lg={10}
              
              sx={{ paddingTop: showWarning ? (isSmallScreen ? 6.5 : 4) : 1 }}
            > */}
              <Grid
                item
                xs={12}
                md={12}
                lg={10}
                sx={{
                  padding: isSmallScreen ? 1: 3,
                  paddingTop: showWarning ? (isSmallScreen ? 6.5 : 4) : 1,
                }}
              >
                <Header onCountryChange={handleCountryChange} />
              </Grid>
              <Grid item xs={12} md={12} lg={10} style={{ width: "100%" }}>
                <Routes>
                  <Route path="/home" element={<HomePage />} />
                  {showAnalytics && (
                    <Route path="/analytics" element={<Analytics />} />
                  )}

                  {/*     <Route path="/home:section" element={<HomePage />} /> */}
                  <Route path="/add-affiliate" element={<AddAffiliateForm />} />

                  <Route
                    path="/blogs/:blogName"
                    element={
                      <EmbeddedHTMLContent title={title} content={content} />
                    }
                  />
                  <Route
                    path="/:slug"
                    element={
                      <EmbeddedHTMLContent title={title} content={content} />
                    }
                  />
                  <Route
                    path="/product-details/:id"
                    element={<ProductDetails />}
                  />
                  <Route path="/all-deals" element={<ProductListing />} />
                  <Route path="/search" element={<ProductListing />} />
                  <Route path="*" element={<Navigate to="/404" replace />} />
                  <Route path="/404" element={<PageNotFound />} />
                </Routes>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Footer />
              </Grid>
           {/*  </Grid> */}
          </Grid>
        </CustomScroll>
      </Stack>
    </div>
  );
}

export default App;
